<section class="privacy-page">
  <div class="privacy-hero">
    <div class="hero-overlay"></div>
    <div class="hero-content">
      <h1>Privacy Policy</h1>
      <p>How Econet Wireless Zimbabwe collects, uses and protects your personal information.</p>
    </div>
  </div>

  <div class="privacy-content">
    <article class="privacy-card">
      <p>
        At Econet Wireless Zimbabwe Limited and our affiliates and subsidiaries (collectively, Econet Wireless), one of our
        main priorities is the privacy of our customers. This Privacy Policy explains the type of information collected across
        our products and services, how we use and disclose that information, your available choices, and how we safeguard
        personal data.
      </p>
      <p>
        If you have additional questions or require more information, please contact us. In addition to this policy, we may
        provide service-specific privacy details where appropriate.
      </p>

      <section class="policy-section">
        <h2>Definitions</h2>
        <ul>
          <li><strong>You:</strong> the person who subscribes to, uses or purchases any of our products and services, or accesses our websites.</li>
          <li><strong>We/Us/Our:</strong> Econet Wireless Zimbabwe Limited and all subsidiaries and affiliates.</li>
          <li><strong>Services:</strong> all products and services offered by Econet Wireless Zimbabwe Limited.</li>
          <li><strong>Data Protection Laws:</strong> applicable laws relating to processing, privacy and use of personal data, including any updates, replacements or related regulatory guidance.</li>
        </ul>
      </section>

      <section class="policy-section">
        <h2>Consent</h2>
        <p>By using our Services, you consent to this Privacy Policy and agree to its terms.</p>
      </section>

      <section class="policy-section">
        <h2>Information We Collect</h2>
        <h3>Information you provide to us</h3>
        <p>
          When you purchase or use our Services, we may ask for personal information that can include the following:
        </p>
        <ul>
          <li>Contact details (name, email address, postal address and phone number)</li>
          <li>Identification details (national ID or passport number)</li>
          <li>Date of birth and gender</li>
          <li>Payment card information</li>
          <li>SIM registration details</li>
          <li>Transaction information when using our Services</li>
          <li>CCTV recordings on our premises for safety and security</li>
        </ul>
        <p>
          If you contact us directly, we may also receive additional details such as message contents and attachments.
          We may obtain information from publicly or commercially available sources and trusted third-party service providers.
        </p>

        <h3>Information collected automatically</h3>
        <p>
          We may collect data automatically using analytics and similar technologies to remember your preferences, understand
          usage patterns, improve service performance, and enhance communications.
        </p>
        <ul>
          <li>Device details (model, IMEI, serial numbers, call data records)</li>
          <li>How you use our Services</li>
          <li>Use of third-party apps, features and services connected to our Services</li>
          <li>Online activity data over time and across connected websites/devices where applicable</li>
        </ul>
      </section>

      <section class="policy-section">
        <h2>How We Use Your Information</h2>
        <p>We use collected information to:</p>
        <ul>
          <li>Provide, operate and maintain Services</li>
          <li>Improve, personalize and expand Services</li>
          <li>Understand usage and develop features/products</li>
          <li>Register, identify and authenticate users</li>
          <li>Provide advertising, including interest-based advertising where permitted</li>
          <li>Conduct analytics, market research and anonymized reporting</li>
          <li>Communicate support, updates, marketing and promotions</li>
          <li>Prevent fraud and other unlawful activity</li>
          <li>Comply with applicable legal and regulatory obligations</li>
        </ul>
        <p>
          We may combine information for these purposes and retain information for as long as legally required under the laws
          of the Republic of Zimbabwe.
        </p>
      </section>

      <section class="policy-section">
        <h2>Cookies and Web Beacons</h2>
        <p>
          We use cookies and similar technologies to help our websites function and improve your experience.
          Cookies may store settings such as language and display preferences so you do not need to re-enter them each visit.
          Our cookies are not designed to identify you personally.
        </p>
      </section>

      <section class="policy-section">
        <h2>How We May Disclose Personal Data</h2>
        <p>Econet Wireless Zimbabwe does not sell personal data. We may disclose personal data when:</p>
        <ul>
          <li>You have explicitly agreed to disclosure</li>
          <li>Disclosure is required to subsidiaries, affiliates or authorized partners to provide requested services</li>
          <li>Disclosure is required by law, legal process, regulators, litigation or public authorities</li>
          <li>It is necessary to prevent physical harm, financial loss, fraud or illegal activity</li>
          <li>Business transfers occur (for example merger, acquisition, reorganization or liquidation)</li>
        </ul>
      </section>

      <section class="policy-section">
        <h2>Third-Party Websites and Policies</h2>
        <p>
          Our Services may link to third-party websites, apps, devices or features with independent privacy practices.
          We encourage you to review their privacy policies. We are not responsible for privacy practices of services not
          owned or controlled by Econet Wireless Zimbabwe.
        </p>
      </section>

      <section class="policy-section">
        <h2>Data Protection Rights</h2>
        <p>Subject to legal and contractual exceptions, you may have the following rights:</p>
        <ul>
          <li>Right of access</li>
          <li>Right to rectification</li>
          <li>Right to erasure</li>
          <li>Right to restrict processing</li>
          <li>Right to object to processing</li>
          <li>Right to data portability</li>
        </ul>
        <p>If you make a request, we generally respond within one month.</p>
      </section>

      <section class="policy-section">
        <h2>International Data Transfers</h2>
        <p>
          Where personal information is transferred outside Zimbabwe, we apply appropriate safeguards in line with applicable
          Data Protection Laws.
        </p>
      </section>

      <section class="policy-section">
        <h2>Children's Information</h2>
        <p>
          We encourage parents and guardians to monitor children's online activity. Econet Wireless Zimbabwe does not knowingly
          collect personally identifiable information from children under 13. If you believe such information was provided,
          please contact us promptly so we can remove it.
        </p>
      </section>

      <section class="policy-section">
        <h2>Updates</h2>
        <p>
          Econet Wireless Zimbabwe may amend this policy from time to time and will attempt to notify users of significant
          changes through appropriate channels. Please check the latest version on our official website.
        </p>
      </section>

      <section class="policy-section contact-block">
        <h2>Contact</h2>
        <p>
          Email: <a href="mailto:enquiries@econet.co.zw">enquiries@econet.co.zw</a><br>
          Address: Econet Park, No. 2 Old Mutare Road, Msasa, Harare, Zimbabwe
        </p>
      </section>
    </article>
  </div>
</section>
